/**
 * Time formatting utilities
 */

// Cached Intl.DateTimeFormat instance (avoid per-call allocation).
// Why: 한국 사내 앱이라 출/퇴근 시각은 항상 KST 기준이어야 함. timeZone 미지정 시 런타임
// 로컬(예: CI=UTC)에 따라 결과가 바뀌어 테스트가 환경 의존이 됨.
const timeShortFormat = new Intl.DateTimeFormat('ko-KR', {
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
  timeZone: 'Asia/Seoul',
});

/**
 * Format ISO string to HH:mm in KST (e.g. "09:30")
 * Returns '-' for null values.
 */
export function formatTimeShort(iso: string | null): string {
  if (!iso) return '-';
  return timeShortFormat.format(new Date(iso));
}

/**
 * Convert ISO string to datetime-local input value (YYYY-MM-DDTHH:mm)
 * Uses local timezone instead of UTC to avoid timezone shift bugs.
 */
/**
 * Format seconds as elapsed timer (e.g. "4:13:00" or "05:30")
 */
export function formatElapsed(seconds: number): string {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const sec = seconds % 60;
  const mm = String(m).padStart(2, '0');
  const ss = String(sec).padStart(2, '0');
  return h > 0 ? `${h}:${mm}:${ss}` : `${mm}:${ss}`;
}

export function formatLocalDateTimeInput(iso: string): string {
  if (!iso) return '';
  const d = new Date(iso);
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
